import { Button } from '@/components/ui/button';

interface InvalidInvitationStateProps {
  onNavigateToLogin: () => void;
}

export default function InvalidInvitationState({ onNavigateToLogin }: InvalidInvitationStateProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-50 dark:bg-primary-950 px-4">
      <div className="w-full max-w-md bg-white dark:bg-primary-900 border border-primary-200 dark:border-primary-800 p-8 text-center">
        <h1 className="text-2xl font-light tracking-tight text-primary-950 dark:text-white mb-4">
          Convite Inválido
        </h1>
        <p className="text-primary-600 dark:text-primary-400 mb-6">
          Este link de convite é inválido ou expirou.
        </p>
        <Button onClick={onNavigateToLogin}>
          Ir para Login
        </Button>
      </div>
    </div>
  );
}
